import React from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { RanchCRS, RANCH_MAP_BOUNDS, RANCH_DEFAULT_CENTER, RANCH_TILE_URL, RANCH_MIN_ZOOM, RANCH_MAX_ZOOM } from '../utils/ranchMap';

const pinIcon = L.divIcon({
    className: '',
    html: '<div style="width:16px;height:16px;border-radius:50%;background:#f59e0b;border:2px solid white;box-shadow:0 0 4px rgba(0,0,0,0.6);"></div>',
    iconSize: [16, 16],
    iconAnchor: [8, 8],
});

function ClickHandler({ onPick }) {
    useMapEvents({
        click(e) {
            onPick([e.latlng.lat, e.latlng.lng]);
        },
    });
    return null;
}

const RanchMap = ({ position, onPick, height = 300 }) => {
    return (
        <MapContainer
            key={position ? 'has-pin' : 'no-pin'}
            crs={RanchCRS}
            center={position || RANCH_DEFAULT_CENTER}
            zoom={position ? RANCH_MAX_ZOOM - 2 : RANCH_MIN_ZOOM + 1}
            minZoom={RANCH_MIN_ZOOM}
            maxZoom={RANCH_MAX_ZOOM}
            maxBounds={RANCH_MAP_BOUNDS}
            style={{ height, width: '100%', borderRadius: '8px' }}
        >
            <TileLayer url={RANCH_TILE_URL} noWrap />
            {position && <Marker position={position} icon={pinIcon} />}
            {onPick && <ClickHandler onPick={onPick} />}
        </MapContainer>
    );
};

export default RanchMap;
